import { TextFieldDE } from "../common/TextFieldDE";

export type StringFields<T> = {
  [K in keyof T]: T[K] extends string | null ? K : never;
}[keyof T];

type ProcessDataTextFieldDEProps<T> = {
  value: string | null | undefined;
  field: StringFields<T>;
  label?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
};

export const ProcessDataTextFieldDE = <T,>({
  value,
  field,
  label,
  disabled,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
}: ProcessDataTextFieldDEProps<T>) => {
  return (
    <TextFieldDE
      label={label || String(field)}
      value={value || ""}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
    />
  );
};
